import React from 'react'
import styled from 'styled-components/native'
import { atlTheme } from '../../atlTheme'
import { BottomMenuTabs } from './BottomMenuTabs'
import { ATLSpacing, SpacingSizesEnum } from '@appsimples/atlantica-react-native'
import { platformConfig } from '../../constants/platform'

const Container = styled.SafeAreaView`
  background: ${atlTheme.ColorBackground};
  justify-content: center;
`

const TabsContainer = styled.View`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  margin-top: 10px;
`

const WebTabsContainer = styled.View`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 95%;
  margin-top: 10px;
  justify-content: space-around;
  margin: auto;
`

export const TabsBottom: React.FunctionComponent = () => {
  return (
    <Container>
      {platformConfig.isWeb() ? (
        <WebTabsContainer>
          <BottomMenuTabs />
        </WebTabsContainer>
      ) : (
        <TabsContainer>
          <BottomMenuTabs />
        </TabsContainer>
      )}
      <ATLSpacing type={SpacingSizesEnum.marginal} />
    </Container>
  )
}
